<template>
  <div class="report">
    <el-tabs tab-position="left" style="min-height: 750px">
      <el-tab-pane
        :label="reportO.publishTime + '发布' + reportO.title"
        v-for="reportO in reportObj"
        :key="reportO.title"
      >
        <h2>{{ reportO.title }}</h2>
        <p class="report-content">
          {{ reportO.content }}
        </p>

        <div>
          <el-row style="padding-top: 10px">
            <el-col :sm="24" :md="8" v-for="(o, sub_index) in 2" :key="o">
              <el-card shadow="never" style="border: none">
                <el-image
                  style="width: 100%; height: 250px"
                  :src="reportO.reportSubImg[sub_index]"
                  fit="contain"
                >
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                </el-image>
                <div style="text-align: justify; font-size: 10px">
                  <span>{{ reportO.reportSubImgTitle[sub_index] }}</span>
                </div>
              </el-card>
            </el-col>
            <el-col
              :sm="24"
              :md="8"
              :style="{ textAlign: 'right', paddingRight: '10px' }"
            >
              <a :href="reportO.reportLink">
                <el-image
                  style="
                    width: 70%;
                    box-shadow: 0px 3px 10px 5px rgba(0, 0, 0, 0.1);
                  "
                  :src="reportO.reportimg"
                  fit="fit"
                >
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                </el-image>
              </a>
            </el-col>
          </el-row>

          <p class="report-paper" v-show="reportO.paper != ''">
            发表论文: {{ reportO.paper }}
          </p>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- <el-timeline>
      <el-timeline-item
        v-for="reportO in reportObj"
        :key="reportO.title"
        :timestamp="reportO.publishTime"
        placement="top"
      >
        <el-card>
          <el-row>
            <el-col :sm="24" :md="16">
              <h2>{{ reportO.title }}</h2>
              <p class="report-content">
                {{ reportO.content }}
              </p>

              <div>
                <el-row style="padding-top: 20px">
                  <el-col
                    :span="11"
                    v-for="(o, sub_index) in 2"
                    :key="o"
                    :offset="sub_index > 0 ? 2 : 0"
                  >
                    <el-card
                      :body-style="{ padding: '2px' }"
                      shadow="never"
                      style="border: none"
                    >
                      <el-image
                        style="width: 100%; height: 250px"
                        :src="reportO.reportSubImg[sub_index]"
                        fit="contain"
                      >
                        <div slot="placeholder" class="image-slot">
                          加载中<span class="dot">...</span>
                        </div>
                      </el-image>
                      <div style="text-align: justify; font-size: 10px">
                        <span>{{ reportO.reportSubImgTitle[sub_index] }}</span>
                      </div>
                    </el-card>
                  </el-col>
                </el-row>
              </div>

              <p class="report-paper" v-show="reportO.paper != ''">
                发表论文: {{ reportO.paper }}
              </p>
            </el-col>
            <el-col :sm="24" :md="8" style="padding-top: 20px">
              <a :href="reportO.reportLink">
                <el-image
                  style="
                    width: 75%;
                    box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.2);
                  "
                  :src="reportO.reportimg"
                  fit="fit"
                >
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                </el-image>
              </a>
            </el-col>
          </el-row>
        </el-card>
      </el-timeline-item>
    </el-timeline> -->
  </div>
</template>

<style scoped>
.el-timeline {
  padding-top: 30px;
  padding-bottom: 20px;
  padding-right: 10px;
  /* padding-left: 5%;
  padding-right: 5%; */
}
.report {
  max-width: 1440px;
  margin: 0 auto;
}
.report-content {
  text-align: justify;
  text-indent: 2em;
  /* font-size: 1.2em; */
  line-height: 30px;
}

.report-paper {
  text-align: justify;
  color: #f56c6c;
}
</style>

<script>
// // @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "ReportsTimeline",
  data() {
    return {
      reportObj: [
        {
          title: "空气质量评估报告(十)",
          publishTime: "2023年4月",
          reportimg: require("@/assets/report_pic10.png"),
          reportLink:
            "https://songxichen.com/Uploads/Files/Report/Air_Quality_Assessment_Report_X.pdf",
          content:
            "本报告在上一份报告基础上增加江西省共 11 个城市 72 个站点，统称“3+110”城市。报告将基于上述九省三市“3+110”城市近 12 年的气象和污染数据，给出其六种常规空气污染物的变化趋势和最新一年污染程度的评估。",
          reportSubImg: [
            require("@/assets/report-img/report_10-1.png"),
            require("@/assets/report-img/report_10-2.png"),
          ],
          reportSubImgTitle: [
            "“3+110”城市2022年二氧化氮和春夏 8 小时臭氧的监视坐标图，其中横向蓝色箭头表示该城市过去三年（相比 2019 年）二氧化氮降幅至少 20%，横向红色箭头表示该城市过去三年（相比 2019 年）二氧化氮增幅至少 20%，春夏两季 8 小时臭氧未用箭头标记降幅。",
            "“3+110”城市2022年超标污染物词云图。城市名称中，绿色代表无污染物超标，橙色代表 1 个污染物超标，紫色代表 2 个污染物超标，红色代表 3 个污染物超标，黑色代表 4 个污染物超标。",
          ],
          paper: "",
        },

        {
          title: "空气质量评估报告(九)",
          publishTime: "2022年4月",
          reportimg: require("@/assets/report_pic9.png"),
          reportLink:
            "https://songxichen.com/Uploads/Files/Report/Air_Quality_Assessment_Report_IX.pdf",
          content:
            "本报告在《空气质量评估报告(八)》的基础上补充内蒙古呼和浩特、包头、鄂尔多斯和乌兰察布 4 市，对“3+99”市的空气质量进一步评估。",
          reportSubImg: [
            require("@/assets/report-img/report_9-1.png"),
            require("@/assets/report-img/report_9-2.png"),
          ],
          reportSubImgTitle: [
            "“3+99”城市2021年PM2.5秋冬和8小时臭氧春夏平均浓度（微克/立方米）散点分布图",
            "“3+99”城市2020年PM2.5秋冬和8小时臭氧春夏平均浓度（微克/立方米）散点分布图",
          ],
          paper: "",
        },

        {
          title: "空气质量评估报告(八)",
          publishTime: "2021年5月",
          reportimg: require("@/assets/report_pic8.png"),
          reportLink:
            "https://www.songxichen.com/Uploads/Files/Report/Air_Quality_Assessment_Report_VIII.pdf",
          content:
            "本报告覆盖的城市范围在去年 “2+66” 城市报告（七）的基础上，增加了上海、安徽、江苏30个城市，共有 “3+95” 个城市，它们拥有全国 40% 的人口，12.5% 的国土面积。",
          reportSubImg: [
            require("@/assets/report-img/report_8-1.jpg"),
            require("@/assets/report-img/report_8-2.jpg"),
          ],
          reportSubImgTitle: [
            "“3+95”城市2020年PM2.5秋冬和8小时臭氧春夏平均浓度（微克/立方米）散点分布图",
            "“3+95”城市2020年PM2.5秋冬和8小时臭氧春夏年平均90%分位数浓度（微克/立方米）散点分布图",
          ],
          paper: "",
        },

        {
          title: "空气质量评估报告(七)",
          publishTime: "2020年7月",
          reportimg: require("@/assets/report_pic7.png"),
          reportLink:
            "https://www.songxichen.com/Uploads/Files/Report/Air_Quality_Assessment_Report_VII.pdf",
          content:
            "发布于2020年7月，覆盖的城市范围在去年“2+43”城市报告的基础上，补齐了山东、河南、山西、陕西余下的城市，统称“2+66”城市。基于这68个城市354个国控空气质量监测站点2013年3月至2020年2月污染物监测数据和78个气象站点2011年3月到2020年2月累积八年的小时气象数据，综合评估“2+66”城市过去七年空气质量的实际状态和变化趋势。",
          reportSubImg: [
            require("@/assets/report-img/report_7-1.png"),
            require("@/assets/report-img/report_7-2.png"),
          ],
          reportSubImgTitle: [
            "气象调整后2013年至2019年PM2.5季节平均浓度(微克/立方米)变化序列图，图中实线(虚线)代表在5%统计学显著水平比上年有(无)显著增加或减少其中2019年冬季也调整了新冠疫情的影响，没有经过疫情调整的值由黑点表示",
            "“2+66”各城市2017至2019季节年大气污染物年均浓度变化幅度对比",
          ],
          paper:
            "Zheng, X-Y., Guo, B., He, J. and Chen, S.X. (2020) Effects of COVID-19 Control Measures on Air Quality in North China, Envirionmentrics (Discussion Paper) to appear",
        },

        {
          title: "空气质量评估报告(六)",
          publishTime: "2019年4月",
          reportimg: require("@/assets/report_pic6.png"),
          reportLink:
            "https://www.songxichen.com/Uploads/Files/Report/Air_Quality_Assessment_Report_VI.pdf",
          content:
            "发布于2019年4月，综合评估了“2+43”城市（相比于报告五增加了汾渭平原11市和延安市）247个国控站点2013年3月至2019年2月的状态和变化趋势。这份报告首次提出“人努力-天帮忙”指数的概念，建议各级政府部门使用去除气象干扰的空气质量评估方法，使得评估大气治理努力程度不受“天帮忙”或“天帮倒忙”的影响。",
          reportSubImg: [
            require("@/assets/report-img/report_6-1.png"),
            require("@/assets/report-img/report_6-2.png"),
          ],
          reportSubImgTitle: [
            "“2+43”城市2013年到2018年气象调整后PM2.5季节平均浓度(微克/立方米)地图(白色代表数据少，无法得到可靠结果)",
            "2018年分季节“人努力”及“天帮忙”图(红色代表不利气象/人不努力，蓝色代表有利气象/人努力，颜色越深，气象/人为的影响越大)",
          ],
          paper: "",
        },

        {
          title: "空气质量评估报告(五)",
          publishTime: "2018年4月",
          reportimg: require("@/assets/report_pic5.png"),
          reportLink:
            "https://www.songxichen.com/Uploads/Files/Report/Air_Quality_Assessment_Report_V.pdf",
          content:
            "发布于2018年4月，综合评估了“2+31”城市（包括京津冀大气污染传输通道“2+26”城市、河北北部3个地级市、与山东济南接壤的泰安、莱芜市）172个国控站点2013年3月至2018年2月的状态和变化趋势。这份报告指出国十条第一阶段目标基本实现。",
          reportSubImg: [
            require("@/assets/report-img/report_5-1.png"),
            require("@/assets/report-img/report_5-2.png"),
          ],
          reportSubImgTitle: [
            "京津冀及周边晋鲁豫地区33市2013年到2017年气象调整后PM2.5季节平均浓度(微克/立方米)地图",
            "“2+31”城市2017年PM10-2.5和PM2.5的监视坐标图(纵向箭头表示该城市四年内PM10-2.5降幅至少25%，横向箭头表示该城市四年内PM2.5降幅至少26%)",
          ],
          paper: "",
        },

        {
          title: "空气质量评估报告(四)",
          publishTime: "2017年8月",
          reportimg: require("@/assets/report_pic4.png"),
          reportLink:
            "https://www.songxichen.com/Uploads/Files/Report/Air_Quality_Assessment_Report_IV.pdf",
          content:
            "发布于2017年8月，分析京津冀2+11城市2013年春到2017年春的空气质量，发现在PM2.5和二氧化硫下降的同时，臭氧浓度在持续升高。报告结果得到媒体的广泛报道。",
          reportSubImg: [
            require("@/assets/report-img/report_4-1.png"),
            require("@/assets/report-img/report_4-2.png"),
          ],
          reportSubImgTitle: [
            "京津冀13市气象调整后PM2.5季节平均值浓度时间序列(微克/立方米)",
            "京津冀13市气象调整后PM2.5季节平均浓度的变化序列(微克/立方米)",
          ],
          paper:
            "Lei Chen, Bin Guo, Jiasheng Huang, Hengfang Wang, Shuyi Zhang and Song Xi Chen (2018). Assessing Air-Quality in Beijing-Tianjin-Hebei Region: the Method and Mixed Tales of PM2.5 and O3. Atmospheric Environment 193 (2018) 290–301.",
        },

        {
          title: "空气质量评估报告(三)",
          publishTime: "2017年3月",
          reportimg: require("@/assets/report_pic3.png"),
          reportLink:
            "https://www.songxichen.com/Uploads/Files/Report/Air_Quality_Assessment_Report_III.pdf",
          content:
            "发布于2017年3月，分析北京36个站点2013到2016年的空气质量，具体刻画了北京市的空气污染分布情况和特征。",
          reportSubImg: [
            require("@/assets/report-img/report_3-1.png"),
            require("@/assets/report-img/report_3-2.png"),
          ],
          reportSubImgTitle: [
            "北京市PM2.5季均值浓度（徼克/立方米）在不同年份的空间分布地图。图中数字代表平均浓度（标准差）。北京的PM2.5均值浓度有很强的季节性，冬季最严重，其次是秋季、春季，夏季最轻。从年度变化的角度来看，不论是中心区域、北部区域还是南部区域，每个季节的PM2.5浓度在2015年和2016年均比2013年和2014年低了很多。这四年中空气质量的显著改善发生在2015年。与2014年相比，中心城区的年均值浓度从2014年的91.1微克/立方米降到2015年的79.8微克/立方米，降幅高达12.4%。",
            "北京市在阅兵前、阅兵中、阅兵后三个时间段六种污染物浓度（微克/立方米）的盒形图。白线为调整均值浓度，矩形区域为95%的置信区间，黑点为原始均值浓度。北京市的三个区域的六种污染物几乎均具有显著的“凹”字型阅兵效果即阅兵前后污染物的浓度高，阅兵中的浓度低。三个区域中，北部的效果最大，南部最低。",
          ],
          paper:
            "Zhang S, Guo B, Dong A, He J, Xu Z, Chen SX. 2017 Cautionary tales on air-quality improvement in Beijing. Proc. R. Soc. A 20170457.",
        },

        {
          title: "空气质量评估报告(二)",
          publishTime: "2016年3月",
          reportimg: require("@/assets/report_pic2.png"),
          reportLink:
            "https://www.songxichen.com/Uploads/Files/Report/Air_Quality_Assessment_Report_II.pdf",
          content:
            "发布于2016年3月，将研究所覆盖的城市增加到五个，运用统计学方法交叉验证我国环保部和美国使领馆在中国五个城市的PM2.5数据，发现两个数据源的数据高度一致。 该文章在著名的《地球物理研究》上发表，证明了中国大气污染数据的质量，回答了一些人对中国大气污染数据质量的质疑。 《纽约时报》报道了该研究结果及其对2013-2015年中国五城市空气质量的评估结果，《参考消息》予以转载。",
          reportSubImg: [
            require("@/assets/report-img/report_2-1.png"),
            require("@/assets/report-img/report_2-2.png"),
          ],
          reportSubImgTitle: [
            "五城市累计降水量（毫米）与PM2.5浓度（微克/立方米）的关系图。红色曲线为非参数回归拟合曲线。无论在哪个城市，随着累积降水量逐渐增大，PM2.5都有显著的下降趋势。其中，当累积降水量大于50毫米时，五个城市的PM2.5浓度都会下降到35微克/立方米以下。",
            "北京冬季供暖对PM2.5的效应。白色实线为剔除气象因素后PM2.5的均值浓度（微克/立方米），盒子表示95%的置信区间，黑点表示未剔除气象因素的原始PM2.5的均值浓度。",
          ],
          paper:
            "Liang, X., Li, S., Zhang, SY, Huang, H. and S.X. Chen (2016). PM2.5 Data Reliability, Consistency and  Air Quality Assessment in Five Chinese Cities,  Journal of Geophysical Research:Atmosphere,  121, 10,220_10,236.",
        },

        {
          title: "空气质量评估报告(一)",
          publishTime: "2015年3月",
          reportimg: require("@/assets/report_pic1.png"),
          reportLink:
            "https://www.songxichen.com/Uploads/Files/Report/Air_Quality_Assessment_Report_I.pdf",
          content:
            "发布于2015年3月，分析北京一个站点2012-2014年的空气质量，首次提出去除气象干扰的方法，用于评估北京冬季供暖和APEC会议对污染的影响。",
          reportSubImg: [
            require("@/assets/report-img/report_1-1.png"),
            require("@/assets/report-img/report_1-2.png"),
          ],
          reportSubImgTitle: [
            "污染过程从污染开始、污染中、严重污染、污染结束到优良空气状态下的风向分布及各风向下的平均风速。污染开始时，西南风比例显著上升，污染中和严重污染时，东南风和静风比例增加，而在污染结束和优良空气时，北风（西北风和东北风）成为主导风向。",
            "四个季节在北风与南风条件下，PM2.5和累积风速的关系。蓝线表示35微克/立方米的PM2.5浓度（空气质量为良的上限）。在不同的季节，持续的北风都会使PM2.5的浓度下降，但是南风却没有这样的效果。",
          ],
          paper:
            "Liang, X., T. Zou, B. Guo, S. Li, H. Zhang, S. Zhang, H. Huang and S. X. Chen. (2015). Assessing Beijing's PM2.5 Pollution: Severity, Weather Impact, APEC and Winter Heating, Proceedings of the Royal Society A, 471, 20150257.",
        },
      ],
    };
  },
  methods: {},
  mounted() {},
};
</script>
